import {
  ID_CONTAINER_20_DRY,
  ID_CONTAINER_20_REEFER,
  ID_CONTAINER_40_DRY,
  ID_CONTAINER_40_REEFER,
  MAX_CONTAINER_20_DRY,
  MAX_CONTAINER_20_REEFER,
  MAX_CONTAINER_40_DRY,
  MAX_CONTAINER_40_REEFER,
} from "actions/constant";
import * as dummyData from "./dummyData";
import * as CryptoJS from "crypto-js";

export const formatRupiah = (angka) => {
  if (!angka && angka === null) return "Rp.0";
  let number_string = angka.toString(),
    split = number_string.split(","),
    sisa = split[0].length % 3,
    rupiah = split[0].substr(0, sisa),
    ribuan = split[0].substr(sisa).match(/\d{3}/gi);

  if (ribuan) {
    let separator = sisa ? "." : "";
    rupiah += separator + ribuan.join(".");
  }

  rupiah = split[1] !== undefined ? rupiah + "," + split[1] : rupiah;
  return rupiah ? "Rp. " + rupiah : "";
};

export const formatCurrency = (bilangan) => {
  if (!bilangan && bilangan === null) return "0";
  let number_string = bilangan.toString(),
    sisa = number_string.length % 3,
    rupiah = number_string.substr(0, sisa),
    ribuan = number_string.substr(sisa).match(/\d{3}/g);

  if (ribuan) {
    let separator = sisa ? "." : "";
    rupiah += separator + ribuan.join(".");
  }

  return rupiah;
};

export const funcPagination = (currentPage, pageTotal) => {
  if (!currentPage && !pageTotal) return null;
  const prevPage = parseInt(currentPage) - 1;
  const nextPage = parseInt(currentPage) + 1;

  let curPage = currentPage;
  let minPage = Number(curPage) - 2;
  let maxPage = Number(curPage) + 2;

  const pagess = [];
  const totalPages = pageTotal;
  for (let index = 1; index <= totalPages; index++) {
    if (pagess.indexOf(index) == -1) {
      pagess.push(index);
    }
  }
  return {
    prevPage,
    nextPage,
    minPage,
    maxPage,
    pages: pagess,
    totalPages,
    curPage,
  };
};

export function formatBytes(bytes, decimals = 2) {
  if (!+bytes) return "0 Bytes";

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
}

export const functionCalculateWeightTotal = (idTypeContainer, productsList) => {
  let totalWeight = 0;
  for (let weight of productsList) {
    totalWeight += Number(weight.berat_total);
  }
  let maxWeight = 0,
    isCompatibleContainer = true;
  if (
    idTypeContainer === ID_CONTAINER_20_DRY ||
    idTypeContainer === 5 ||
    idTypeContainer === 6
  ) {
    maxWeight = MAX_CONTAINER_20_DRY;
  } else if (idTypeContainer === ID_CONTAINER_20_REEFER) {
    maxWeight = MAX_CONTAINER_20_REEFER;
  } else if (idTypeContainer === ID_CONTAINER_40_DRY) {
    maxWeight = MAX_CONTAINER_40_DRY;
  } else if (idTypeContainer === ID_CONTAINER_40_REEFER) {
    maxWeight = MAX_CONTAINER_40_REEFER;
  } else {
    isCompatibleContainer = false;
  }
  return isCompatibleContainer ? totalWeight > maxWeight : false;
};

export const statusConsigneeApprovalLCL = (approve_consignee_status) => {
  // 0 = request approve, 1 = approve, -1 = reject
  if (approve_consignee_status === null)
    return { labelLCL: "-", colorLabel: "secondary" };
  let labelLCL = "",
    colorLabel = "",
    isCanDelete = true;

  if (Number(approve_consignee_status) === 0) {
    labelLCL = "Request Approve Consignee";
    colorLabel = "warning";
    isCanDelete = true;
  } else if (Number(approve_consignee_status) === 1) {
    labelLCL = "Telah Approve Consignee";
    colorLabel = "success";
    isCanDelete = false;
  } else if (Number(approve_consignee_status) === -1) {
    labelLCL = "Di Tolak Consignee";
    colorLabel = "danger";
    isCanDelete = true;
  }

  return { labelLCL, colorLabel, isCanDelete };
};

export const encryptAes = (plainText, urlSafe = false) => {
  const aesKey = "tDKsiapWqiIeiZks";
  const aesIV = "PoIyBFgsXAqLUHjaV";
  const key = CryptoJS.enc.Utf8.parse(aesKey);
  const iv = CryptoJS.enc.Utf8.parse(aesIV);

  try {
    let chiperText = CryptoJS.AES.encrypt(plainText, key, { iv: iv });
    let base64 = chiperText.toString();

    if (urlSafe) {
      base64 = base64.replace(/\+/g, "-");
      base64 = base64.replace(/\//g, "_");
    }

    return base64;
  } catch (error) {
    console.log(error);
    return false;
  }
};

export const operatorPriceLabel = (label) => {
  let title = "";
  if (label === "tarif_bongkar_destination") {
    title = "Tarif Bongkar Destination";
  } else if (label === "tarif_depo_origin") {
    title = "Tarif Depo Origin";
  } else if (label === "tarif_depo_destination") {
    title = "Tarif Depo Destination";
  } else if (label === "tarif_bongkar_origin") {
    title = "Tarif Bongkar Origin";
  }

  return title;
};

export { dummyData };
